<mat-form-field [id]="activity.inputControlID" floatLabel="never">
  <mat-select
    class="goals-select"
    [formControl]="activityControl"
    [required]="activity.isRequired"
    [(ngModel)]="activity.ans"
    [placeholder]="activity.hint"
    [matTooltip]="getTooltipText(activity)"
    matTooltipPosition="above"
    matTooltipClass="calculator-matTooltip"
    (selectionChange)="populateDependvalues(activity.ans)"
  >
    <mat-option
      *ngFor="let option of activity['values']"
      [value]="option.value"
      [matTooltip]="getTooltip(option.name)"
      matTooltipClass="calculator-matTooltip"
      matTooltipPosition="right"
    >
      {{ option.name }}
    </mat-option>
  </mat-select>
  <mat-error class="m-top-8" *ngIf="activityControl.hasError('required')"
    >{{ "Required" | translate }}*
  </mat-error>
</mat-form-field>
